import { createFileRoute } from '@tanstack/react-router';
import { useContext } from 'react';

import { usePermissions } from '../../../../api/me.js';
import { PermissionDeniedPage, WebsiteNotFoundPage } from '../../../../components/SectionStates.js';
import { WebsiteStatusContext } from '../../../../components/WebsiteSection.js';
import { KnowledgePage } from '../../../../knowledge/KnowledgePage.js';
import { parseKnowledgeSearch } from '../../../../knowledge/search.js';

/**
 * The Knowledge section (`features/website-knowledge/ux.md`, Destinations).
 * Which list is shown, the search and the page number live in the URL
 * (`patterns/frontend-conventions.md`, 1).
 */
export const Route = createFileRoute('/_app/websites/$websiteId/knowledge')({
  validateSearch: parseKnowledgeSearch,
  component: KnowledgeRoute,
});

const TITLE = 'Knowledge';

function KnowledgeRoute() {
  const { websiteId } = Route.useParams();
  const { view = 'approved', q = '', page = 1 } = Route.useSearch();
  const permissions = usePermissions();
  const websiteStatus = useContext(WebsiteStatusContext);

  // The nav already hides the section; this covers an opened URL
  // (`patterns/ui-patterns.md`, 3). Nothing is requested.
  if (!permissions.includes('knowledge')) {
    return <PermissionDeniedPage title={TITLE} permission="knowledge" />;
  }
  if (websiteStatus === 'not-found') return <WebsiteNotFoundPage title={TITLE} />;

  return <KnowledgePage key={websiteId} websiteId={websiteId} view={view} q={q} page={page} />;
}
